import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @impements UseCase
 */

class CheckOpenHoursCustomerCareUseCase extends UseCase {
  constructor({config, checkOpenHoursCustomerCareService, dateValueObjectFactory}) {
    super()
    this._config = config
    this._checkOpenHoursCustomerCareService = checkOpenHoursCustomerCareService
    this._dateValueObjectFactory = dateValueObjectFactory
  }

  @inlineError
  async execute({date}) {
    const dateVO = this._dateValueObjectFactory({
      date
    })

    const [error, response] = await this._checkOpenHoursCustomerCareService.execute(dateVO)

    if (error) return Promise.reject(error)

    return response
  }
}

export {CheckOpenHoursCustomerCareUseCase}
